import React from 'react';
import './WhyProgressive.css';
import ycrm from '../assetsprogressive/ycrm.png'
import tick from '../assetsprogressive/tick.svg'

export default function WhyProgressive() {
      const data = [
        {
            title:"End-to-End CRM Expertise - ",
            text:"From strategy and design to development and support, we deliver complete CRM solutions."
        },
        {
             title:"Skilled & Experienced Team - ",
            text:" A certified team of developers and consultants with deep expertise in leading CRM platforms and tailored solutions."
        },
        {
             title:"Customize Solutions for Your Business - ",
            text:"Custom CRM systems designed to fit your workflows and scale with your growth."
        },
        {
             title:"Proven Results & Global Support - ",
            text:"Hundreds of successful CRM projects with 24/7 support for seamless operations."
        }
    ]

  return (
    <div id='whyprogressive' className="progressive-wrapper">
                <div className="containermain">
                    <div className="whycrmLeft">
                        <img src={ycrm} alt="ycrm" />
                    </div>
                    <div className="whycrmRight">
                        <h1 className="h1-tag">
                       Why Us
                        </h1>
                        <p className="title">
                        Partner with us to transform your customer relationships and streamline your business operations with expert CRM solutions.
</p>
                        <div className="ycrmsection">
                            {
                                data.map((item,index)=>{
                                    return(
                                        <div className="ycrmitem" key={index}>
                                            <img src={tick} alt="tick" />
                                            <p className='subHeading'><span>{item.title}</span>{item.text}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
    </div>
  )
}
